import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "chartContainer",
  class: "w-full h-[calc(100%-2rem)] relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorOverlay = _resolveComponent("ErrorOverlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ErrorOverlay, {
      show: _ctx.errorShown,
      icon: "error_outline",
      message: "情報の取得中にエラーが発生しました<br>後でもう一度お試しください"
    }, null, 8, ["show"])
  ], 512))
}